/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_product.js'

//   ####   ####  #####     #####   ##      ##
//  ##     ##     ##  ##   ##   ##  ##      ##
//   ###   ##     #####    ##   ##  ##      ##
//     ##  ##     ##  ##   ##   ##  ##      ##
//  ####    ####  ##   ##   #####   ######  ######

/**
 * @function scrollValToggle
 * @description スクロール量を基準にクラスを着脱する
 * @param {String} targetSelector ターゲットとする一意なセレクタ
 * @param {Number} scrollValStart 有効範囲となるスクロール量　上からの距離
 * @param {Number|Boolean} [scrollValEnd=false] 有効範囲外となるスクロール量　下からの距離
 * @param {String} toggleClass 切り替えるクラス名
 * @return {Void}
 */

if (!document.getElementById('minHeader')) {
  scrollValToggle('#header', 500, false, 'active')
} else {
  document.getElementById('header').classList.add('active')
}

function scrollValToggle(targetSelector, scrollValStart = 500, scrollValEnd = false, toggleClass = 'active') {
  if (!document.querySelector(targetSelector)) {
    return
  }
  let isExecute = false // 実行中フラグ
  let scrollY = 0 // 縦方向のスクロール量
  const target = document.querySelector(targetSelector) // ターゲット要素
  let scToggleActive = false // ターゲット要素のONOFF状態
  document.addEventListener('scroll', function (ev) {
    scrollValToggleApply()
  })
  scrollValToggleApply() // 初回起動
  function scrollValToggleApply() {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      if (scrollY >= scrollValStart && !scToggleActive) {
        //トップから指定px以上スクロールしたらON
        target.classList.add(toggleClass)
        scToggleActive = true
      } else if (scrollY < scrollValStart && scToggleActive) {
        //スクロールが足りない時はOFF
        target.classList.remove(toggleClass)
        scToggleActive = false
      }
      if (scrollValEnd && scToggleActive) {
        // 終了ラインが設定されている場合は終了判定
        if (scrollY + window.innerHeight > document.documentElement.offsetHeight - scrollValEnd) {
          //スクロール終了範囲を過ぎていたらOFF
          target.classList.remove(toggleClass)
          scToggleActive = false
        }
      }
      isExecute = false
    })
  }
}

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.animatedを付加
// Intersection Observer
window.intObs = function () {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-10% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}
window.intObs()
